import { Pipe, PipeTransform } from '@angular/core';
import { TenantDto } from '../../api/core';

@Pipe({
    name: 'liebherrTenantName',
})
export class GetTenantNamePipe implements PipeTransform {
    transform(id: string | undefined, tenants: TenantDto[]) {
        return tenants.find((t) => t.id === id)?.name || '-';
    }
}
